<template>
  <div>
    <a-modal
      v-show="!ishand"
      id="warp_sim12"
      width="40rem"
      v-model="visible"
      on-ok="handleOk1"
      v-dragModal
      @cancel="handleCancel(0)"
      :footer="null"
      :keyboard="false"
      :maskClosable="false"
      :dialog-style="{top: 22 +'%'}"
    >
      <div class="mark-file">
        <div
          style="
            background-color: #0c8b97;
            border-radius: 10px 10px 0 0;
            color: #fff;
            width: 38rem;
            margin: 1rem 1rem 0 1rem;
            text-align: center;
          "
        >
          <span style="font-size: 1rem;">預約開戶</span>
        </div>
      </div>
      <div solt="title" style="position: relative">
        <!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
      </div>
      <div class="content">
        <div style="padding-top: 1.5rem; position: relative; left: -0.8rem">
          <a-form-model
            ref="ruleForm"
            :model="formItem"
            labelAlign="right"
            layout="inline"
            hideRequiredMark
            :rules="rules"
          >
            <a-row style="margin-top:0.5rem">
              <a-col :span="12">
                <a-form-model-item prop="name" label="中文名稱">
                  <a-input
                    v-model="formItem.name"
                    placeholder="請輸入中文名稱"
                    auto-complete="new-accounts"
                    :maxLength="10" 
                    :blur="formItem.name=formItem.name=formItem.name.replace(/[^\u4e00-\u9fa5]+/g, '')"
                  />
                  </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="email" label="電郵地址">
                  <a-input
                    v-model="formItem.email"
                    placeholder="請輸入電郵地址"
                    :blur="formItem.email=formItem.email=formItem.email.replace(/[\u4E00-\u9FA5]/g, '')" 
                    />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row  style="margin-top:0.5rem">
              <a-col :span="12">
                <a-form-model-item prop="cal" label="稱謂">
                  <a-select ref="select" v-model="formItem.cal" :placeholder="'請選擇稱謂'" style="width: 100%">
                    <a-select-option value="0">先生</a-select-option>
                    <a-select-option value="1">小姐</a-select-option>
                    <a-select-option value="3">太太</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="phonenum" label="聯絡電話">
                  <div style="display:flex">
                    <div style="width:35%;flex-shrink: 0;margin-right: 0.5rem;position: relative;">
                      <el-select v-model="formItem.nationcode" style="width:100%;" @change="qhclick">
                        <el-option v-for="item in qhArr" :key="item.id" :label="'+' + item.value" :value="item.value">
                          <span style="font-size: 14px; float: left">{{item.label}}&ensp;</span>
                          <span style="font-size: 14px; float: right"><span v-if="item.id != 11 ">+</span>{{item.value}}</span>
                        </el-option>
                      </el-select>
                      <div style="position: absolute;color: #606266;top: 4px;left:1px;height: 80%;display: flex;align-items: center;justify-content: center;
                            width: 70%;background: #fff;border-radius: 4px;">
                        <div v-if="!qhflag">+{{formItem.nationcode}}</div>
                        <div class="qh_input" v-else style="display: flex;align-items: center;justify-content: center;">
                          <div style="margin-left: 10px;font-size: 16px;">+</div>
                          <a-input onkeyup="value=value=value.replace(/[^\d]/g,'')" :maxLength="3" v-model="formItem.nationcode"/>
                        </div>
                      </div>
                    </div>
                    <div>
                      <a-input v-model="formItem.phonenum" v-if="formItem.nationcode=='852'" :maxLength="8" onkeyup="value=value=value.replace(/[^\d]/g,'')" placeholder="請輸入聯絡電話" />
                      <a-input v-model="formItem.phonenum" v-else :maxLength="11" onkeyup="value=value=value.replace(/[^\d]/g,'')" placeholder="請輸入聯絡電話" />
                    </div>
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row  style="margin-top:0.5rem">
              <a-col :span="12">
                <a-form-model-item prop="date" label="預約日期">
                  <a-date-picker format="DD/MM/YYYY" :disabled-date="disabledDate" :inputReadOnly='true' v-model="formItem.date" @change="yyDate()" placeholder="請選擇預約日期" style="width:100%" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="time" label="預約時間">
                  <a-select v-model="formItem.time" placeholder="請選擇預約時間" style="width: 100%">
                    <a-select-option value="9:00-10:00">9:00-10:00</a-select-option>
                    <a-select-option value="10:00-11:00">10:00-11:00</a-select-option>
                    <a-select-option value="11:00-12:00">11:00-12:00</a-select-option>
                    <a-select-option value="12:00-13:00" disabled>12:00-13:00</a-select-option>
                    <a-select-option value="13:00-14:00">13:00-14:00</a-select-option>
                    <a-select-option value="14:00-15:00">14:00-15:00</a-select-option>
                    <a-select-option value="15:00-16:00">15:00-16:00</a-select-option>
                    <a-select-option value="16:00-17:00">16:00-17:00</a-select-option>
                    <a-select-option value="17:00-18:00">17:00-18:00</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>

          <div style="text-align: center;margin:0.5rem 0">
            <button
              class="btn1 btnx"
              @click="handleCancel(1)"
              v-html="'提&emsp;交'"
            ></button>
          </div>
        </div>
      </div>
      <div style="width: 100%; height: 1px"></div>
    </a-modal>
  </div>
</template>

<script>
import App from "@/assets/app.js";
import dayjs from 'dayjs';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from "moment";
export default {
  props: [],
  data() {
    return {
      qhflag: false,
      ishand: false,
      visible: true,
      locale:zhCN,
      userfileAuditAdmin: this.$store.state.rolesdata.indexOf("userfileAuditAdmin") >= 0,
      holidaylist:[],
      formItem:{
        name:'',
        email:'',
        cal:undefined,
        nationcode:'852',
        phonenum:'',
        time:undefined,
        date:'',
      },
      qhArr: [
        {
          id: "1",
          value: "86",
          label: '中國',
        },
        {
          id: "2",
          value: "852",
          label: '中國香港',
        },
        {
          id: "3",
          value: "853",
          label: '中國澳門',
        },
        {
          id: "4",
          value: "61",
          label: '澳大利亞',
        },
        {
          id: "5",
          value: "1",
          label: '加拿大',
        },
        {
          id: "6",
          value: "60",
          label: '馬來西亞',
        },
        {
          id: "7",
          value: "1",
          label: '美國',
        },
        {
          id: "8",
          value: "65",
          label: '新加坡',
        },
        {
          id: "9",
          value: "64",
          label: '新西蘭',
        },
        {
          id: "10",
          value: "44",
          label: '英國',
        },
        {
          id: "11",
          value: "",
          label: '其他',
        },
      ],
      rules: {
        name: [{ required: true, message: "" }],
        cal: [{ required: true, message: "" }],
        phonenum: [{ required: true, message: "" }],
        emailAddress: [{ required: true, message: "" }],
        time: [{ required: true, message: "" }],
        date: [{required: true,message: ' '}],
      },
    };
  },
  mounted() {
    moment.locale("zh-cn");
    this.getHolidayList()
  },
  methods: {

    qhclick(val){
      if(!val){
        this.qhflag = true
      }else{
        this.qhflag = false
      }
    },
    disabledDate(current ){
      const monthEnd = moment().endOf('month')
      // const monthStart = moment().startOf('month')
      const monthOfday = parseInt(moment().format('D'))
      const days = moment(current).format('YYYY-MM-DD');
      return current && current < dayjs().endOf('day') || moment(current).format('d') == 6||moment(current).format('d') == 0||this.holidaylist.includes(days)||current > monthEnd.add('days', 60 + monthOfday);
    },
    getHolidayList(){
      this.$ajax({
        method:'post',
        url:this.$api.getHolidayList,
        data:{}
      }).then(res=>{
        if(res.data.qmiscode === 1000){
          this.holidaylist = res.data.holidaylist
        }
      })
    },
    handleCancel(ev) {
      if(ev == 1){
        this.$refs.ruleForm.validate((valid) => { 
        if (valid) {
          this.$ajax({
            method: "post",
            url: this.$api.newWebYuyue2,
            data:this.formItem,
          }).then((res) => {
            if (res.data.qmiscode == 1000) {
              App.oTool.successT();
              this.$emit("child", this.formItem);
            } else {
              App.oTool.warningT(res.data.qmismsg);
              this.$emit("child", this.formItem);
            }
          });
        }
      })
      }else{
        this.$emit("child", this.formItem);
      }
    },
    yyDate(){
      if (this.formItem.date) {
        this.formItem.date = this.yyTime3(this.formItem.date._d)
      }
      console.log(this.formItem.date);
    },
    yyTime3(today) {
      if(!today){return ''}
      var month = today.getMonth() + 1;
      month = month < 10 ? '0'+month : month;
      var day = today.getDate() < 10 ? '0'+today.getDate() : today.getDate();
      return today.getFullYear() + '-' + month + '-' + day;
    },
  },
};
</script>

<style lang="scss">
  .qh_input .ant-input{
    border: none !important;
    height: 95% !important;
    box-shadow: none !important;
    padding: 0 !important;
  }
  .el-icon-arrow-up:before{
    font-family: 'element-icons' !important;
  }
  .el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner{
    border-color:#279da3 !important;
  }
  .el-input__inner{
    height:35.5px

  }
  .el-select .el-input__inner:focus{
    border-color:#279da3 !important;
  }
  .el-select-dropdown__item.selected{
    color: rgba(0,0,0,.65) !important;
    font-weight: 400 !important;
    font-size: 16px !important;
  }
.phoneSty .ant-select-arrow {
  right: 6px !important;
}
.phoneSty .ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 28% !important;
}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix {
  left: 2px !important;
  top: 18px;

}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix :not(.anticon),
.ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {
  line-height: 25.5px !important;
}
.phoneSty .ant-select-selection {
  border: 0 !important;
  height: 25px;
}
.phoneSty .ant-select-focused .ant-select-selection,
.ant-select-selection:active,
.ant-select-selection:focus {
  border: 0 !important;
  box-shadow: none !important;
}


.address .ant-form-item-label {
  width: 15% !important;
}
.address .ant-form-item-control-wrapper {
  width: 85% !important;
}
.content {
  padding-bottom: 1rem;
  border-radius: 0 0 10px 10px;
  padding: 1rem;
  background-color: #fff;
  width: 38rem;
  margin: 0 auto;
  margin-bottom: 1rem;
  min-height: 50px;
}
#warp_sim12 .ant-modal-header,
#warp_sim12 .ant-modal-body {
  background-color: #e5e5e5 !important;
  padding: 1rem;
  padding-top: 0.7rem;
}

.mark-file {
  position: absolute;
  top: 0;
  left: 0;

  div {
    width: 6rem;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    display: inline-block;
  }
}

#warp_sim12 {
  .ant-radio-wrapper {
    display: flex;
    align-items: center;
  }
  .ant-form-explain {
    display: none;
  }

  .ant-modal {
    top: 28%;
  }

  .ant-col-12 {
    text-align: right;
  }
  .myleft {
    text-align: left;
  }
  .ant-form-item-label {
    width: 30%;
  }

  .ant-form-item,
  .ant-form-item-control {
    width: 100%;

    .ant-calendar-picker {
      width: 100%;
    }
  }

  .ant-radio-group-default {
    width: 100%;
    margin-top: 0.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 0.8rem;
    }
  }

  .ant-form-item-control-wrapper {
    width: 70%;

    .ant-form-item-control {
      width: 100%;
    }
  }

  #lastname {
    text-align: right;

    .ant-form-item-label {
      width: 10%;
    }

    .ant-form-item-control-wrapper {
      width: 86%;
    }
  }

  .ant-form-inline .ant-form-item {
    margin-right: 0;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-form-item {
    margin-bottom: 1rem;
  }

  .ant-form-item label {
    font-size: 0.8rem !important;
  }

  .ant-input {
    font-size: 0.8rem !important;
  }

  .ant-select-selection-selected-value {
    font-size: 0.8rem !important;
  }

  .ant-form-item-children {
    font-size: 0.8rem !important;
  }

  .ant-modal-body {
    padding: 0;
    padding-top: 2.5rem;
  }

  .btn1 {
    cursor: pointer;
    width: 8rem;
    height: 2rem;
    font-size: 0.8rem;
    color: #fff;
    border: 0;
    border-radius: 5px;
    margin: 0 3rem;
  }

  .btnx {
    background-color: #0c8b97;
  }

  .btn2 {
    background-color: #ed4849;
  }

  .mydivs {
    max-height: 7rem;
    overflow-y: auto;
    // margin-bottom: 1rem;
    padding: 1rem;
    margin-left: 4%;
    width: 96%;
    background-color: #f5f5f5;
    margin-bottom: 1rem;

    .c {
      font-size: 0.8rem;
    }

    .f {
      // text-align: right;
      display: flex;
      justify-content: space-between;
    }

    .t {
      margin: 0.5rem 0;
      border-bottom: 1px solid #d9d9d9;
    }
  }
}
</style>
